import organizations from './organizations';
import userPermissions from './userPermissions';

export default {
  organizations,
  userPermissions,
};
